import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type ChatbotKebabInteractionOption =
  | "delete"
  | "rename"
  | "change_owner"
  | "share"
  | "move"
  | "duplicate";

export function useEmitChatbotKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: ChatbotKebabInteractionOption, chatbotId?: string) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.TableKebab,
        optionSelected,
        customTrackingFields: {
          chatbot_id: chatbotId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
